import * as _ from "lodash";
// React
import React from "react";
// Redux
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { configureStore } from "configureStore";
// Routing
import { syncHistoryWithStore } from "react-router-redux";
import { Router, Route, IndexRoute, browserHistory } from "react-router";
import * as AppRouting from "./appRouting";
import * as applicationActions from "app/application/actions";
import * as domainUser from "user/user/User";
import * as userActions from "user/user/actions";
//-- Frame ------------------------------------------------------------------------------------
import { AppFrame } from "app/application/ui/AppFrame";
//-- Modes ------------------------------------------------------------------------------------
import AppMode from "app/application/ui/modes/AppMode";
import { BadUrlMode } from "app/application/ui/modes/BadUrlMode";
import { LoginMode } from "app/application/ui/modes/LoginMode";
//-- Views ------------------------------------------------------------------------------------
//-- Authentication
import { VerifyRequestView } from "user/authentication/ui/views/VerifyRequestView";
import { VerifyView } from "user/authentication/ui/views/VerifyView";
import { LoginView } from "user/authentication/ui/views/LoginView";
import { ForgotPasswordView } from "user/authentication/ui/views/ForgotPasswordView";
import { ForgotPasswordResetView } from "user/authentication/ui/views/ForgotPasswordResetView";
import AuthFlexContainer from "user/authentication/ui/views/components/AuthFlexContainer";
//-- Settings
import ProfileView from "user/profile/ProfileView";
import SettingsView from "user/SettingsView";
import ContactUsView from "app/contactUs/ui/ContactUsView";
//-- Home
import { HomeView } from "app/home/HomeView";
//-- Products
import OfficeProductsView from "products/OfficeProductsView";
import FeaturedAgentsProductsView from "products/widgets/FeaturedAgentsProductsView";
import FeaturedListingsProductsView from "products/widgets/FeaturedListingsProductsView";
import SpotlightProductsView from "products/widgets/SpotlightProductsView";
//-- External Feed
import ExternalFeedOfficeView from "external/reports/officeStats/ExternalFeedOfficeView";
//-- Office ------------------------------------------------------------------------------------
//-- Landing
import OfficeHomeView from "app/home/OfficeHomeView";
import OfficeReportsView from "office/reports/OfficeReportsView";
//-- Active Listings
import ActiveListingsReportView from "office/reports/activeListings/ActiveListingsReportView";
//-- Leads
import OfficeLeadsReportView from "office/reports/leads/OfficeLeadsReportView";
//-- Agents
import AgentsReportView from "office/reports/agents/AgentsReportView";
//-- Stats
import OfficeStatsReportView from "office/reports/stats/OfficeStatsReportView";
import OrderHdListingsView from "./products/orderHdListings/OrderHdListingsView";
import SummaryPage from "office/reports/stats/pages/SummaryPage";
import SalesPage from "office/reports/stats/pages/SalesPage";
import RentalsPage from "office/reports/stats/pages/RentalsPage";
import DevelopmentPage from "office/reports/stats/pages/DevelopmentPage";
import BillboardPage from "office/reports/stats/pages/BillboardPage";
//-- Agency ------------------------------------------------------------------------------------
//-- Landing
import AgencyHomeView from "app/home/AgencyHomeView";
import AgencyReportsView from "agency/reports/AgencyReportsView";
//-- Overview
import OverviewReportView from "agency/reports/overview/OverviewReportView";
//-- Components ------------------------------------------------------------------------------------
import { ContentPanel } from "app/application/ui/ContentPanel";
import { ReportsTransitionWrapper, SubReportsTransitionWrapper } from "common/ui/containers/routeTransitionWrapper/RouteTransitionWrapper";
//-- Helpers
import { initialiseResizeHelper } from "common/resizeHelper";
//-- Start up ------------------------------------------------------------------------------------
//-- Globally set Moment to use Monday as the start of the week
import moment from "moment";
moment.updateLocale('en', {
    week: {
        dow: 1 // Monday is the first day of the week
    }
});
//-- Initialise resize helper
initialiseResizeHelper();
//-- Create Store
const store = configureStore();
//-- Calculate form path strings
import * as authenticationForms from "user/authentication/reducer";
authenticationForms.configureFormStrings(store.getState().authenticationForms);
import * as orderHdListingsForms from "products/orderHdListings/reducer";
orderHdListingsForms.configureFormStrings(store.getState().products.orderHdListings);
//-- Initialise the history
const history = syncHistoryWithStore(browserHistory, store);
const mapStateToProps = (state) => {
    return {
        application: state.app.app,
        user: state.user,
        reports: state.reports,
        routing: state.routing
    };
};
const mapDispatchToProps = (dispatch) => ({
    userActions: bindActionCreators(userActions, dispatch),
    applicationActions: bindActionCreators(applicationActions, dispatch),
    dispatch: dispatch
});
//-- Component ------------------------------------------------------------------------------------
class AppAgentDesk extends React.Component {
    constructor(props) {
        super(props);
        this._routes = (React.createElement(Route, { path: "/" },
            React.createElement(Route, { component: AppFrame },
                React.createElement(Route, { component: AppMode, onEnter: (routerState, redirectFunction, args) => this.requireUserData(routerState, redirectFunction, args) },
                    React.createElement(Route, { component: ContentPanel },
                        React.createElement(Route, { component: ReportsTransitionWrapper },
                            React.createElement(IndexRoute, { component: HomeView }),
                            React.createElement(Route, { path: AppRouting.settingsPath(), component: SettingsView }),
                            React.createElement(Route, { path: AppRouting.contactUsPath(), component: ContactUsView }),
                            React.createElement(Route, { path: AppRouting.profileUserPath(), component: ProfileView }))),
                    React.createElement(Route, { component: ContentPanel },
                        React.createElement(Route, { component: ReportsTransitionWrapper },
                            React.createElement(Route, { path: AppRouting.officePath(), component: OfficeHomeView }),
                            React.createElement(Route, { path: AppRouting.officeReportsPath(), component: OfficeReportsView }),
                            React.createElement(Route, { path: AppRouting.officeListingReportPath(), component: ActiveListingsReportView }),
                            React.createElement(Route, { path: AppRouting.officeLeadsReportPath(), component: OfficeLeadsReportView }),
                            React.createElement(Route, { path: AppRouting.officeAgentsReportPath(), component: AgentsReportView }),
                            React.createElement(Route, { path: AppRouting.officeStatsReportPath(), component: OfficeStatsReportView, onEnter: (x, y) => this.redirectToSummary(x, y) },
                                React.createElement(Route, { component: SubReportsTransitionWrapper },
                                    React.createElement(IndexRoute, { component: SummaryPage }),
                                    React.createElement(Route, { path: AppRouting.officeStatsSummaryReportPath(), component: SummaryPage }),
                                    React.createElement(Route, { path: AppRouting.officeStatsSalesReportPath(), component: SalesPage }),
                                    React.createElement(Route, { path: AppRouting.officeStatsRentalsReportPath(), component: RentalsPage }),
                                    React.createElement(Route, { path: AppRouting.officeStatsDevelopmentsReportPath(), component: DevelopmentPage }),
                                    React.createElement(Route, { path: AppRouting.officeStatsBillboardsReportPath(), component: BillboardPage }))))),
                    React.createElement(Route, { component: ContentPanel },
                        React.createElement(Route, { component: ReportsTransitionWrapper },
                            React.createElement(Route, { path: AppRouting.agencyPath(), component: AgencyHomeView }),
                            React.createElement(Route, { path: AppRouting.agencyReportsPath(), component: AgencyReportsView }),
                            React.createElement(Route, { path: AppRouting.agencyStatsReportPath(), component: OverviewReportView }))),
                    React.createElement(Route, { component: ContentPanel },
                        React.createElement(Route, { component: ReportsTransitionWrapper },
                            React.createElement(Route, { path: AppRouting.productsPath(), component: OfficeProductsView }),
                            React.createElement(Route, { path: AppRouting.productsOrderHdListingsViewPath(), component: OrderHdListingsView }),
                            React.createElement(Route, { path: AppRouting.productsFeaturedListingsPath(), component: FeaturedListingsProductsView }),
                            React.createElement(Route, { path: AppRouting.productsSpotlightListingsPath(), component: SpotlightProductsView }),
                            React.createElement(Route, { path: AppRouting.productsFeaturedAgentsPath(), component: FeaturedAgentsProductsView })))),
                React.createElement(Route, { path: AppRouting.userPath(), component: LoginMode },
                    React.createElement(Route, { component: ContentPanel },
                        React.createElement(Route, { component: ReportsTransitionWrapper },
                            React.createElement(Route, { component: AuthFlexContainer },
                                React.createElement(IndexRoute, { onEnter: (x, y) => this.redirectTo(x, y, AppRouting.loginPath()) }),
                                React.createElement(Route, { path: AppRouting.loginPath(), component: LoginView }),
                                React.createElement(Route, { path: AppRouting.requestVerifyPath(), component: VerifyRequestView }),
                                React.createElement(Route, { path: AppRouting.verifyPath(), component: VerifyView }),
                                React.createElement(Route, { path: AppRouting.forgotPasswordPath(), component: ForgotPasswordView }),
                                React.createElement(Route, { path: AppRouting.resetPasswordPath(), component: ForgotPasswordResetView })))))),
            React.createElement(Route, { path: AppRouting.externalFeedPath },
                React.createElement(Route, { path: AppRouting.externalFeedStatsReportPath, component: ExternalFeedOfficeView })),
            React.createElement(Route, { component: AppFrame },
                React.createElement(Route, { path: "*", component: BadUrlMode }))));
    }
    redirectToSummary(nextState, replace) {
        if (!_.includes(nextState.location.pathname, "/stats/")) {
            const officeId = parseInt(nextState.params.officeId);
            replace(AppRouting.officeStatsSummaryReportUrl(officeId));
        }
    }
    requireUserData(nextState, replace, callBack) {
        const { user } = this.props;
        if (!user || !user.userInfo) {
            // Get the user data
            userActions.getUserDataStartUp(this.props.dispatch)
                .then(() => { }, () => { replace(AppRouting.loginPath()); });
        }
        else {
            if (this.isAuthorised(user, nextState)) {
                this.props.dispatch(applicationActions.createAction_PageAuthorisation(true));
            }
            else {
                this.props.dispatch(applicationActions.createAction_PageAuthorisation(false));
            }
        }
        callBack();
    }
    isAuthorised(user, nextState) {
        if (nextState.params.agencyId) {
            return this.hasAgencyAccess(user, nextState);
        }
        else if (nextState.params.officeId) {
            return this.hasOfficeAccess(user, nextState);
        }
        else {
            return true;
        }
    }
    hasAgencyAccess(user, nextState) {
        const access = user.userAccess.find(access => access.type == domainUser.EntryType.Agency && access.id === parseInt(nextState.params.agencyId));
        return access !== null;
    }
    hasOfficeAccess(user, nextState) {
        const access = user.userAccess.find(access => access.type == domainUser.EntryType.Office && access.id === parseInt(nextState.params.officeId));
        return access !== null;
    }
    // Perform a redirect to the listings URL by default
    redirectTo(nextState, replace, targetUrl) {
        replace(targetUrl);
    }
    render() {
        return (React.createElement(Router, { history: history }, this._routes));
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(AppAgentDesk);
export { store as theStore, };
